import React from 'react';
import { Avatar, Box, ButtonBase, Stack, Typography } from '@mui/material';
import { MOBILE_TOP_BAR_HEIGHT } from './constants';

const LOGO_SRC = '/assets/images/logo.png';

export default function MobileTopBar({ title, sectionTitle, userName, onOpenAccount }) {
  return (
    <Box
      component="header"
      sx={(theme) => ({
        flexShrink: 0,
        pt: 'env(safe-area-inset-top)',
        bgcolor: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.94)' : 'rgba(15, 23, 42, 0.94)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid',
        borderColor: 'divider',
        zIndex: theme.zIndex.appBar,
      })}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ height: MOBILE_TOP_BAR_HEIGHT, px: 2 }}
      >
        <Box
          component="img"
          src={LOGO_SRC}
          alt="SMAI Express"
          sx={{ width: 32, height: 32, objectFit: 'contain', flexShrink: 0 }}
        />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          {sectionTitle && sectionTitle !== title && (
            <Typography variant="caption" color="text.secondary" noWrap component="p" sx={{ lineHeight: 1.1 }}>
              {sectionTitle}
            </Typography>
          )}
          <Typography variant="subtitle1" noWrap component="h1" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
            {title || 'SMAI Express'}
          </Typography>
        </Box>
        <ButtonBase
          onClick={onOpenAccount}
          aria-label="Open account"
          sx={{ borderRadius: '50%' }}
        >
          <Avatar
            alt={userName}
            sx={{ width: 34, height: 34, bgcolor: 'primary.main', color: 'primary.contrastText', fontSize: 15, fontWeight: 700 }}
          >
            {userName?.trim()?.charAt(0)?.toUpperCase()}
          </Avatar>
        </ButtonBase>
      </Stack>
    </Box>
  );
}
